module.exports = __webpack_public_path__ + "nunito-sans-latin-700.1aa5d63eca4940fbbb5181895e9bc008.woff";